import { render, staticRenderFns } from "./AddNewAddress.vue?vue&type=template&id=afa7a690&"
import script from "./AddNewAddress.vue?vue&type=script&lang=js&"
export * from "./AddNewAddress.vue?vue&type=script&lang=js&"
import style0 from "./AddNewAddress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports